import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClinicalMessageListComponent } from './clinical-message-list/clinical-message-list.component';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import { AdvancedModeModule } from '../shared/advanced-mode/advanced-mode.module';
import { SharedModule } from '../shared/shared.module';
import { ClinicalMessageListService } from '../core/service/grid-data/grid-data-clinical-message.service';
import { ClinicalMessageDetailComponent } from './clinical-message-detail/clinical-message-detail.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';



@NgModule({
  declarations: [ClinicalMessageListComponent, ClinicalMessageDetailComponent],
  imports: [
    CommonModule,
    BreadcrumbModule,
    AdvancedModeModule,
    SharedModule,
    NgxJsonViewerModule
  ],
  providers: [ClinicalMessageListService],
  exports: [
    ClinicalMessageListComponent
  ]
})
export class ClinicalMessageModule { }
